export const LANGUAGES = {
  en: 'en'
}
